<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Subscribe Blockchain Circle (BCC)</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Do you want to gain access to the BlockChain Circle? Subscribe now
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div
			v-if="form.errors.subscription"
			class="alert alert-danger shadow"
			role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">Please choose subscription</h3>
			<p class="mb-0">{{ form.errors.subscription }}</p>
		</div>
		<div v-if="$page.props.flash && $page.props.flash.title" class="alert" 
			:class="$page.props.flash.title=='Status Success' ? 'alert-success' :'alert-danger'" role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ $page.props.flash.title }}</h3>
			<p class="mb-0">{{ $page.props.flash.message }}</p>
		</div>
		<div v-if="!$page.props.flash && pending" class="border border-default p-4 bg-white">
			<h3 class="fs-5 fw-bold mb-1">Transaction Status</h3>
			<p>
				<span v-if="pending.status==null">The transaction is still <span class="text-danger fw-bold">pending</span> and the payment process is not yet complete</span>
				<span v-else>{{pending.message}}</span>
			</p>
			<p class="my-2 fw-bold">
				Below is the details:
			</p>
			<div>
				<p class="my-1">Registered: {{pending.rdate}} @ {{pending.rtime}}</p>
				<p class="my-1">Payment Method: {{pending.mop}}</p>
				<p class="my-1">Subscription: {{pending.course}}</p>
			</div>
		</div>
	</div>
	
	<div class="content">
		<div class="row">
			<div class="col-xl-5 col-lg-5">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Subscription</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="row">
							<div
								class="col-12"
								v-for="product in products"
								:key="product.prod_id"
							>
								<div class="form-check form-block mb-3">
									<input
										v-model="form.subscription"
										class="form-check-input"
										type="radio"
										:value="product.prod_id"
										:id="product.prod_id"
										name="subscription"
									/>
									<label class="form-check-label" :for="product.prod_id">
										<span class="d-flex align-items-center">
											<h6 class="fs-sm mb-0">
												{{ product.membership_type }}
											</h6>
											<span
												v-if="product.add_display"
												class="badge bg-warning ms-1"
											>
												{{ product.add_display }}
											</span>
										</span>
										<small>&#8369;{{ product.amount }}</small>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Payment method</h3>
					</div>
					<div class="block-content block-content-full">
						<form @submit.prevent="addBCC">
							<div class="row">
								<div class="col-12">
									<div class="row">
										<div class="col-6">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'CARD'"
													id="card"
													name="payment_method"
												/>
												<label class="form-check-label" for="card">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/stripe-logo.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div>
										<div class="col-6">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'DRAGONPAY'"
													id="dragonpay"
													name="payment_method"
												/>
												<label class="form-check-label" for="dragonpay">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/dragonpay-logo.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div>
										<!-- <div class="col-4">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'BROPAY'"
													id="bropay"
													name="payment_method"
												/>
												<label class="form-check-label" for="bropay">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/bropay-logo.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div> -->
									</div>
								</div>
							</div>
							<div v-if="form.mop == 'CARD'">
								<div v-if="has_card" class="form-check form-switch mb-4">
									<input
										v-model="form.use_existing_card"
										class="form-check-input"
										type="checkbox"
										:value="true"
										id="example-switch-default1"
										name="example-switch-default1"
									/>
									<label class="form-check-label" for="example-switch-default1">
										Use existing card
									</label>
								</div>
								<div v-if="has_card && form.use_existing_card" class="mb-4">
									<p class="mb-0">
										<span class="fw-semibold">CARD:</span>
										<i>**** **** **** {{ card.card_last4 }}</i>
										<span class="badge bg-primary ms-2">{{ card.brand }}</span>
									</p>
								</div>
								<div v-else class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
								<div class="mb-4">
									<div class="form-check">
										<input
											v-model="form.agree"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="register3-terms"
											name="register3-terms"
										/>
										<label class="form-check-label" for="register3-terms">
											I agree with the terms & conditions.
										</label>
									</div>
								</div>
							</div>
							<button
								type="submit"
								class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
								:disabled="
									form.processing ||
									!form.isDirty ||
									(form.mop === 'CARD' &&
										!form.token &&
										!form.use_existing_card) ||
									(form.mop === 'CARD' && !form.agree)
								"
							>
								<span v-if="!form.processing">Subscribe</span>
								<span v-else>
									<div class="spinner-border spinner-border-sm text-dark" role="status" >
										<span class="sr-only mr-1">Please wait...</span>
									</div>
									<span class="mx-2">Please wait...</span>
								</span>
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, watch } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../Shared/Components/Stripe'

export default {
	layout: AuthLayout,
	props: {
		test: String,
		products: Object,
		has_card: Boolean,
		card: Object,
		pending: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			subscription: null,
			mop: 'CARD',
			agree: false,
			token: null,
			use_existing_card: props.has_card ? true : false,
			test: props.test,
		})

		const acceptToken = (token) => {
			form.token = token
		}

		const addBCC = () => {
			form.post(route('member.post.bcc-subscribe'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		watch(
			() => form.mop,
			(mop) => {
				
				if(mop=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(mop!='CARD')
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		return {
			form,
			addBCC,
			acceptToken,
		}
	},
}
</script>
